import { render } from "preact";
import { App } from "./app";
import "./styles/global.css";

// V2-7: visualViewport 监听把键盘高度写入 CSS 变量 --keyboard-inset
// 兜底 iOS 17.0-17.3（interactive-widget=resizes-content 不稳定）。
// 17.4+ 浏览器自己 resize content 时这个值通常是 0，不冲突。
function installKeyboardInsetWatcher() {
  if (!window.visualViewport) return;
  const update = () => {
    const inset = Math.max(0, window.innerHeight - window.visualViewport!.height);
    document.documentElement.style.setProperty("--keyboard-inset", `${inset}px`);
  };
  window.visualViewport.addEventListener("resize", update);
  window.visualViewport.addEventListener("scroll", update);
  update();
}

installKeyboardInsetWatcher();

const root = document.getElementById("app");
if (!root) throw new Error("#app missing");
render(<App />, root);
